import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./DataTableModel";
import AutoRefreshDiagramUI from '../AutoRefreshDiagramUI';
import DataTable from "./DataTable";

export default class UI extends AutoRefreshDiagramUI {

    state = {
        data: []
    };

    constructor(props, context) {
        super(props, context);
    }

    needRefresh() {
        this.props.model.refreshData();
    }

    componentDidMount() {
        super.componentDidMount();
        this.setData();
    }

    onPropertyValueChanged(name, oldVal, newVal, subName) {
        super.onPropertyValueChanged(name, oldVal, newVal, subName);
        if (['dataValue'].indexOf(name) > -1) {
            this.setData();
        }
    }

    setData() {
        let data = this.props.model.getData();
        this.setState({
            data
        });
    }

    render() {
        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}  >
                <DataTable rows={this.state.data} columns={this.props.model.columns} option={this.props.model} />
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "数据表",
    catalog: "图表（已废弃）",
    svg: "#anticon-biaoge",
    uiGetter: (model) => <UI model={model} />
});